import {createAction, handleActions} from 'redux-actions';
import {call, put, takeLatest} from 'redux-saga/effects';
import createRequestSaga, {createRequestActionTypes} from '../../api/createRequestSaga';
import * as vocaAPI from '../../api/admin/voca';
import {finishLoading, startLoading} from '../loading';

// 액션 타입
const INITIALIZE = 'voca/INITIALIZE';
const INITIALIZE_FILTER = 'voca/INITIALIZE_FILTER';
const INITIALIZE_SEARCH_RESULT = 'voca/INITIALIZE_SEARCH_RESULT';
const INITIALIZE_VALIDATION_RESULT = 'voca/INITIALIZE_VALIDATION_RESULT';
const CHANGE_FIELD = 'voca/CHANGE_FIELD';
const [READ_WORD_LIST, READ_WORD_LIST_SUCCESS, READ_WORD_LIST_FAILURE] = createRequestActionTypes('voca/READ_WORD_LIST');
const [CREATE_WORD, CREATE_WORD_SUCCESS, CREATE_WORD_FAILURE] = createRequestActionTypes('voca/CREATE_WORD');
const [UPDATE_WORD, UPDATE_WORD_SUCCESS, UPDATE_WORD_FAILURE] = createRequestActionTypes('voca/UPDATE_WORD');
const [DELETE_WORD, DELETE_WORD_SUCCESS, DELETE_WORD_FAILURE] = createRequestActionTypes('voca/DELETE_WORD');
const [SEARCH_SCENARIO, SEARCH_SCENARIO_SUCCESS, SEARCH_SCENARIO_FAILURE] = createRequestActionTypes('voca/SEARCH_SCENARIO');
const [VALIDATE_WORD, VALIDATE_WORD_SUCCESS, VALIDATE_WORD_FAILURE] = createRequestActionTypes('voca/VALIDATE_WORD');

// 액션 생성 함수
export const initialize = createAction(INITIALIZE);
export const initializeFilter = createAction(INITIALIZE_FILTER);
export const initializeSearchResult = createAction(INITIALIZE_SEARCH_RESULT);
export const initializeValidationResult = createAction(INITIALIZE_VALIDATION_RESULT);

export const changeField = createAction(
    CHANGE_FIELD,
    ({ name, value }) => ({ name, value })
);

export const readWordList = createAction(
    READ_WORD_LIST,
    ({ standardWord, useWord, category, page }) => ({ standardWord, useWord, category, page })
);

export const createWord = createAction(
    CREATE_WORD,
    ({ category, standardWord, useWordList }) => ({ category, standardWord, useWordList })
);

export const updateWord = createAction(
    UPDATE_WORD,
    ({ category, id, standardWord, useWordList }) => ({ category, id, standardWord, useWordList })
);

export const deleteWord = createAction(
    DELETE_WORD,
    ({ category, deleteVoca }) => ({ category, deleteVoca })
);

export const searchScenario = createAction(
    SEARCH_SCENARIO,
    ({ name }) => ({ name })
);

export const validateWord = ({ category, target, value, resolve, reject }) => ({
    type: VALIDATE_WORD,
    payload: { category, target, value },
    resolve,
    reject
});

// 사가
// const readWordListSaga = createRequestSaga(READ_WORD_LIST, vocaAPI.readWordList);
function* readWordListSaga(action) {
    yield put(startLoading(READ_WORD_LIST));
    try {
        const response = yield call(vocaAPI.readWordList, action.payload);
        yield put({
            type: READ_WORD_LIST_SUCCESS,
            payload: response.data
        })
    } catch (e) {
        yield put({
            type: READ_WORD_LIST_FAILURE,
            payload: e,
            error: true
        })
    }
    yield put(finishLoading(READ_WORD_LIST));
}

function* createWordSaga(action) {
    yield put(startLoading(CREATE_WORD));
    try {
        const response = yield call(vocaAPI.createWord, action.payload);
        yield put({
            type: CREATE_WORD_SUCCESS,
            payload: response.data
        });
        yield put(initializeFilter());
        yield put(readWordList({
            standardWord: initialState.standardWord,
            useWord: initialState.useWord,
            category: action.payload.category ? action.payload.category : initialState.category,
            page: initialState.page
        }));
    } catch (e) {
        yield put({
            type: CREATE_WORD_FAILURE,
            payload: e,
            error: true
        })
    }

    yield put(finishLoading(CREATE_WORD));
}

function* updateWordSaga(action) {
    yield put(startLoading(UPDATE_WORD));

    try {
        const response = yield call(vocaAPI.updateWord, action.payload);
        yield put({
            type: UPDATE_WORD_SUCCESS,
            payload: response.data
        });
        yield put(initializeFilter());
        yield put(readWordList({
            standardWord: initialState.standardWord,
            useWord: initialState.useWord,
            category: action.payload.category ? action.payload.category : initialState.category,
            page: initialState.page
        }));
    } catch (e) {
        yield put({
            type: UPDATE_WORD_FAILURE,
            payload: e,
            error: true
        })
    }

    yield put(finishLoading(CREATE_WORD));
}

function* deleteWordSaga(action) {
    yield put(startLoading(DELETE_WORD));

    try {
        const response = yield call(vocaAPI.deleteWord, action.payload);
        yield put({
            type: DELETE_WORD_SUCCESS,
            payload: response.data
        });
        yield put(initializeFilter());
        yield put(readWordList({
            standardWord: initialState.standardWord,
            useWord: initialState.useWord,
            category: action.payload.category ? action.payload.category : initialState.category,
            page: initialState.page
        }));
    } catch (e) {
        yield put({
            type: DELETE_WORD_FAILURE,
            payload: e,
            error: true
        })
    }

    yield put(finishLoading(CREATE_WORD));
}

function* searchScenarioSaga(action) {
    const { name } = action.payload;
    try {
        const response = yield call(vocaAPI.searchScenario, name);
        const scenarioResponse = response.data.data;
        yield put({
            type: SEARCH_SCENARIO_SUCCESS,
            payload: scenarioResponse
        });
    } catch (e) {
        yield put({
            type: SEARCH_SCENARIO_FAILURE,
            payload: e,
            error: true
        });
    }
}

function* validateWordSaga(action) {
    try {
        const response = yield call(vocaAPI.validateUniqueWord, action.payload);
        yield put({
            type: VALIDATE_WORD_SUCCESS,
            payload: response.data.data
        });
        if (action.resolve) {
            action.resolve(response.data.data);
        }
    } catch (e) {
        yield put({
            type: VALIDATE_WORD_FAILURE,
            payload: e,
            error: true
        });
        if (action.reject) {
            action.reject(e);
        }
        throw e;
    }
}

export function* vocaSaga() {
    yield takeLatest(READ_WORD_LIST, readWordListSaga);
    yield takeLatest(SEARCH_SCENARIO, searchScenarioSaga);
    yield takeLatest(CREATE_WORD, createWordSaga);
    yield takeLatest(UPDATE_WORD, updateWordSaga);
    yield takeLatest(DELETE_WORD, deleteWordSaga);
    yield takeLatest(VALIDATE_WORD, validateWordSaga);
}

// 상태
const initialState = {
    page: 1,
    category: 'WORD',
    standardWord: null,
    useWord: null,
    listResponse: null,
    listErrorResponse: null,
    pagination: null,
    createResponse: null,
    createErrorResponse: null,
    updateResponse: null,
    updateErrorResponse: null,
    deleteResponse: null,
    deleteErrorResponse: null,
    searchScenarioResponse: null,
    searchScenarioErrorResponse: null,
    validateWordResponse: null,
    validateWordErrorResponse: null
};

// 리듀서
const voca = handleActions(
    {
        [INITIALIZE]: () => (initialState),
        [INITIALIZE_FILTER]: (state) => ({
            ...state,
            standardWord: null,
            useWord: null,
            page: 1
        }),
        [INITIALIZE_SEARCH_RESULT]: (state) => ({
            ...state,
            searchScenarioResponse: null,
            searchScenarioErrorResponse: null
        }),
        [INITIALIZE_VALIDATION_RESULT]: (state) => ({
            ...state,
            validateWordResponse: null,
            validateWordErrorResponse: null
        }),
        [CHANGE_FIELD]: (state, { payload: { name, value }} ) => ({
            ...state,
            [name]: value
        }),
        [READ_WORD_LIST_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            listResponse: data.data.content,
            listErrorResponse: null,
            pagination: data.data.pagination
        }),
        [READ_WORD_LIST_FAILURE]: (state, { payload: error }) => ({
            ...state,
            listResponse: null,
            listErrorResponse: error,
            pagination: null
        }),
        [CREATE_WORD_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            createResponse: response.data
        }),
        [CREATE_WORD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            createErrorResponse: error
        }),
        [UPDATE_WORD_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            updateResponse: response.data
        }),
        [UPDATE_WORD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            updateErrorResponse: error
        }),
        [DELETE_WORD_SUCCESS]: (state, { payload: deleteResponse }) => ({
            ...state,
            deleteResponse
        }),
        [DELETE_WORD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            deleteErrorResponse: error
        }),
        [SEARCH_SCENARIO_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            searchScenarioResponse: response,
            searchScenarioErrorResponse: null
        }),
        [SEARCH_SCENARIO_FAILURE]: (state, { payload: error }) => ({
            ...state,
            searchScenarioResponse: null,
            searchScenarioErrorResponse: error
        }),
        [VALIDATE_WORD_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            validateWordResponse: response,
            validateWordErrorResponse: null
        }),
        [VALIDATE_WORD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            validateWordResponse: null,
            validateWordErrorResponse: error
        })
    },
    initialState
);

export default voca;
